import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { getErrorMessage } from '@/utils/errorMessage';
import { AdminService } from '../admin.service';
import { removeAdminData, setAdminData } from '@/utils/cookies';
import { logoutBeforeLoginIfNeeded } from '@/utils/logoutBeforeLogin';

export const useLoginAdmin = (onSuccess?: () => void) => {
	const queryClient = useQueryClient();

	const createClinicMutation = useMutation({
		mutationFn: async ({
			email,
			password,
		}: {
			email: string;
			password: string;
		}) => {
			await logoutBeforeLoginIfNeeded(queryClient);
			return AdminService.login({ email, password });
		},
		onSuccess: (data) => {
			if (data.admin) {
				setAdminData(data.admin);
			}
			toast.success('Login com sucesso!');
			if (onSuccess) onSuccess();
		},
		onError: (error: unknown) => {
			toast.error(getErrorMessage(error, 'Email e/ou senha inválida'));
		},
	});

	return createClinicMutation;
};

export const useLogoutAdmin = (onSuccess?: () => void) => {
	const queryClient = useQueryClient();

	const createClinicMutation = useMutation({
		mutationFn: () => AdminService.logout(),
		onSuccess: () => {
			removeAdminData();

			queryClient.removeQueries({ queryKey: ['admin-me'], exact: true });

			if (onSuccess) onSuccess();
		},
		onError: (error: unknown) => {
			toast.error(getErrorMessage(error, 'Erro no logout'));
		},
	});

	return createClinicMutation;
};
